import { Stack, type StackProps, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { getInitials } from "web_myplann/Shared/Utils/getInitials";

type Props = Omit<StackProps, "children"> & {
	name: string;
	photo?: string;
	size?: number;
};

export const InitialsAvatar: FC<Props> = ({
	name,
	photo,
	size = 80,
	sx,
	...stackProps
}) => {
	const theme = useTheme();

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			{...stackProps}
			sx={[
				{
					width: size,
					height: size,
					borderRadius: "50%",
					overflow: "hidden",
					bgcolor: theme.palette.blue[100],
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
		>
			{photo ? (
				<img
					src={photo}
					alt={name}
					width={size}
					height={size}
					style={{ objectFit: "cover" }}
				/>
			) : (
				<Typography
					color={theme.palette.blue[700]}
					fontSize={size * 0.3}
					fontWeight={700}
					lineHeight={1}
				>
					{getInitials(name)}
				</Typography>
			)}
		</Stack>
	);
};
